import React, { Component } from 'react';
import './NavIcon.css';
import Link from './Link';

// Text navigation shares the Home/Help button treatment. Retain this component's
// existing name so its callers and account-dropdown actions remain unchanged.
class NavIcon extends Component {
  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleOutsideClick = event => {
    if (this.props.showDropdown && this.node && !this.node.contains(event.target)) {
      this.props.onMenuClick('');
    }
  };

  handleKeyDown = event => {
    if (event.key === 'Escape' && this.props.showDropdown) {
      event.preventDefault();
      this.props.onMenuClick('');
      this.toggle.focus();
    }
  };

  render() {
    const { label, action, active = false, showDropdown = false, menuTop, menuList, notifyCount = 0 } = this.props;
    const hasMenuList = menuList && menuList.length > 0;

    if (!hasMenuList) {
      return (
        <Link className="menuPageLink menuAccountLink"
          href={this.props.href || '/' + action} noTarget={true}
          aria-label={notifyCount > 0 ? label + ', ' + notifyCount + ' unread messages' : label}
          aria-current={active ? 'page' : undefined}>
          {label}
          {notifyCount > 0 && <span className="menuUnreadBadge" aria-hidden="true">{notifyCount < 100 ? notifyCount : '99+'}</span>}
        </Link>
      );
    }

    return (
      <div className="menuNavItem" ref={node => this.node = node} onBlur={event => {
        if (showDropdown && event.relatedTarget && !event.currentTarget.contains(event.relatedTarget)) this.props.onMenuClick('');
      }}>
        <button type="button" className="menuPageLink menuAccountLink"
          ref={node => this.toggle = node} aria-expanded={showDropdown}
          aria-controls={'account-navigation-' + action} data-active={active || undefined}
          onClick={() => this.props.onMenuClick(showDropdown ? '' : action)}>
          {label}
          <svg className="menuChevron" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false">
            <path d="m4 6 4 4 4-4" fill="none" stroke="currentColor" strokeWidth="1.8" />
          </svg>
        </button>
        {showDropdown && <div className="menuActionDropdown" id={'account-navigation-' + action}>
          <div className="menuDropdownTop">{menuTop}</div>
          {menuList.map(item => item.action === 'logout' ? (
            <button key={item.action} type="button" name={item.action} className="menuDropdownLink menuLogoutButton" onClick={event => {
              this.props.onMenuClick('');
              this.props.onNavigateMenu(event, item.action);
            }}>{item.label}</button>
          ) : (
            <Link key={item.action} href={'/' + item.action} noTarget={true} className="menuDropdownLink">{item.label}</Link>
          ))}
        </div>}
      </div>
    );
  }
}

export default NavIcon;
